// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.dial_container_nzqCf {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.dial_dial-container_h3Hx6 {
  position: relative;
}

.dial_dial-face_SAVq7,
.dial_dial-handle_Xa2Te,
.dial_gauge_Q93ZG {
  position: absolute;
  top: 0;
  left: 0;
  overflow: visible;
}

.dial_dial-face_SAVq7 {
  width: 100%;
}

.dial_dial-handle_Xa2Te {
  cursor: pointer;
  width: 40px;
  height: 40px;
  /* Use margin to make positioning via top/left easier */
  margin-left: calc(40px / -2);
  margin-top: calc(40px / -2);
}

.dial_gauge-path_MDfiK {
  fill: var(--looks-transparent);
  stroke: var(--looks-secondary);
  stroke-width: 1px;
}
`, "",{"version":3,"sources":["webpack://./src/components/direction-picker/dial.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,uDAAuD;EACvD,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;AACnB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.container {\n  padding: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.dial-container {\n  position: relative;\n}\n\n.dial-face,\n.dial-handle,\n.gauge {\n  position: absolute;\n  top: 0;\n  left: 0;\n  overflow: visible;\n}\n\n.dial-face {\n  width: 100%;\n}\n\n.dial-handle {\n  cursor: pointer;\n  width: 40px;\n  height: 40px;\n  /* Use margin to make positioning via top/left easier */\n  margin-left: calc(40px / -2);\n  margin-top: calc(40px / -2);\n}\n\n.gauge-path {\n  fill: var(--looks-transparent);\n  stroke: var(--looks-secondary);\n  stroke-width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `dial_container_nzqCf`,
	"dial-container": `dial_dial-container_h3Hx6`,
	"dialContainer": `dial_dial-container_h3Hx6`,
	"dial-face": `dial_dial-face_SAVq7`,
	"dialFace": `dial_dial-face_SAVq7`,
	"dial-handle": `dial_dial-handle_Xa2Te`,
	"dialHandle": `dial_dial-handle_Xa2Te`,
	"gauge": `dial_gauge_Q93ZG`,
	"gauge-path": `dial_gauge-path_MDfiK`,
	"gaugePath": `dial_gauge-path_MDfiK`
};
export default ___CSS_LOADER_EXPORT___;
